var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"cz2__copyright"},[_vm._v(" "+_vm._s(_vm.$t('KNICKS_COPYRIGHT'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }